// funciones para internet.
//import * as FxLog from './FxLog';

export const isDebug = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "";
export const isOnline = () => typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;

export const getIP = async () => {
  return fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => data.ip)
    .catch(error => { 
      //FxLog.errorx("FxInet.getIP", error);
      return null;
    });
}

/**
 * Fetches geolocation data for a given IP address and returns a formatted location string.
 * This function does not require user permissions as it relies on an external IP geolocation API.
 *
 * @param {string} ipAddress The IP address to geolocate.
 * @returns {Promise<string>} A promise that resolves to a formatted string of the location,
 * or an error message if the lookup fails.
 */
export const getIpLocation = async (ipAddress) => {
  if (!ipAddress) {
    return "No IP address provided.";
  }

  try {
    // Using ip-api.com, a common free IP geolocation API.
    // Remember to check their terms for usage limits in production.
    const response = await fetch(`http://ip-api.com/json/${ipAddress}`);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    if (data.status === 'fail') {
      // API specific error, e.g., invalid IP.
      return `Failed to get location: ${data.message || 'Unknown error from API.'}`;
    }

    // Format the location data into a readable string
    const parts = [];
    if (data.city) parts.push(data.city);
    if (data.regionName) parts.push(data.regionName); // e.g., Andalusia
    if (data.country) parts.push(data.country);

    if (parts.length === 0) {
      return "Location details not found for this IP.";
    }

    return parts.join(', '); // e.g., "Madrid, Community of Madrid, Spain"
  } catch (error) {
    console.error("Error fetching IP location:", error);
    return `Error fetching location: ${error.message}`;
  }
};

